import {useLocalSearchParams} from "expo-router";
import UserProfilePage from "@/lib/pages/UserProfilePage";
import Page from "@/lib/pages/Page";

export default function Index() {
    const {username} = useLocalSearchParams();

    return (
        <Page scrollable={true}>
            <UserProfilePage username={username.toString()} detailed={true}/>
        </Page>
    )
}